import { Inject, Injectable, DOCUMENT } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ManagementPageSessionStorageService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  read<T>(key: string): T | null {
    const rawState = this.getStorage()?.getItem(key);
    if (!rawState) {
      return null;
    }

    try {
      return JSON.parse(rawState) as T;
    } catch {
      this.clear(key);
      return null;
    }
  }

  save<T>(key: string, state: T) {
    try {
      this.getStorage()?.setItem(key, JSON.stringify(state));
    } catch {
      this.clear(key);
    }
  }

  clear(key: string) {
    try {
      this.getStorage()?.removeItem(key);
    } catch {
      return;
    }
  }

  private getStorage(): Storage | null {
    try {
      return this.document.defaultView?.sessionStorage ?? null;
    } catch {
      return null;
    }
  }
}
